/*
 * Fallback-loader voor "EcomTraffic - Bestsellers".
 *
 * Wanneer een block geen collection heeft (de dynamic source
 * product.metafields.ecomtraffic.related_items is dan leeg), markeert
 * sections/et-bestsellers.liquid het panel met data-et-recommendations-*.
 * Deze loader haalt dan producten op via Shopify's Recommendations API
 * (Search & Discovery) en injecteert de slides in de bestaande swiper.
 *
 * De intents worden op volgorde geprobeerd; de eerste die producten
 * teruggeeft wint. `complementary` volgt de handmatige koppelingen uit
 * Search & Discovery, `related` valt terug op het algoritme van Shopify.
 */
(function () {
  const SECTION_ID = 'et-bestsellers-recommendations';

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  async function fetchSlides(productId, intent, limit) {
    const url = `${rootUrl()}recommendations/products?section_id=${SECTION_ID}&product_id=${productId}&intent=${intent}&limit=${limit}`;

    try {
      const response = await fetch(url);
      if (!response.ok) return [];

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      return Array.from(doc.querySelectorAll('.swiper-slide'));
    } catch (error) {
      console.error('[et-bestsellers] recommendations fetch mislukt', error);
      return [];
    }
  }

  /**
   * Vult het panel met aanbevolen producten.
   * @returns {Promise<boolean>} true als er slides zijn geïnjecteerd.
   */
  async function load(panel) {
    const productId = panel.dataset.etRecommendationsProductId;
    const wrapper = panel.querySelector('.swiper-wrapper');
    if (!productId || !wrapper) return false;

    const limit = panel.dataset.etRecommendationsLimit || '8';
    const intents = (panel.dataset.etRecommendationsIntents || 'complementary,related')
      .split(',')
      .map((intent) => intent.trim())
      .filter(Boolean);

    for (const intent of intents) {
      const slides = await fetchSlides(productId, intent, limit);

      if (slides.length) {
        // appendChild adopteert de nodes in het hoofddocument, waardoor de
        // custom elements van quick-add alsnog upgraden.
        wrapper.replaceChildren(...slides);
        panel.dataset.etRecommendationsState = 'loaded';
        return true;
      }
    }

    panel.dataset.etRecommendationsState = 'empty';
    return false;
  }

  window.EtBestsellersRecommendations = { load };
})();
